module.exports = __webpack_public_path__ + "static/img/banner5ls.76b93f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/banner5ls.jpg
// module id = 1VTB
// module chunks = 0